import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202606",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 6265,
  clicks: 149,
  adsSpendDollars: 1178,
  budgetDollars: 1500,
  salesDollars: 11072,
  bestEstimateRoas: 9.4,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.79,
  newCustomersAcquired: 8,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
